export default __webpack_public_path__ + "static/media/checkmark.faaf4bbe.svg";